import * as React from "react";
import styled from "styled-components";
import { useStableHistory } from "../../hooks/useStableHistory";
import { useObservableApiCall } from "--client/common/apis/hooks/useObservableApiCall";
import { CurrentAuthToken } from "--client/common/TypedStore";
import { authSitemap } from "--root/sitemaps/sitemaps";
import Color from "color";
import { Strings } from "--client/../strings/en";
import { SitemapRouteProps } from "../../../sitemap";
import { AuthSitemapRouting } from "--client/../static_types/sitemaps/auth";
import { TabbedSurface } from "--floponents-web/molecules/TabbedSurface";
import { WorkspaceTitle } from "--floponents-web/molecules/WorkspaceTitle/WorkspaceTitle";

export const AuthBackground = styled.div`
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.palette.primary.main};
    background: ${props => `
        linear-gradient(180deg, ${props.theme.palette.primary.darker} 0%, ${Color(props.theme.palette.primary.darker).alpha(0).toString()} 25% 90%, ${props.theme.palette.primary.darker} 100%),
        radial-gradient(circle, ${props.theme.palette.primary.lighter}, ${props.theme.palette.primary.main} 50%, ${props.theme.palette.primary.darker} 90%)
    `};
`;
const LoginSurface = styled(TabbedSurface)`
    width: 520px;
    max-width: 95vw;
    text-align: center;
`;

const StyledWorkspaceTitle = styled(WorkspaceTitle)`
    margin: 20px 0px;
`

type AuthMenuProps = SitemapRouteProps<
    Pick<
        AuthSitemapRouting,
        | "/auth/join/:error?"
        | "/auth/verify/:identity_type/:address/:code?"
        | "/auth/forgotPassword"
        | "/auth"
        | "/auth/login/:error?"
    >
>

export const AuthTabs: React.FC<AuthMenuProps> = props => {
    const history = useStableHistory();
    useObservableApiCall(() => CurrentAuthToken.subscriber, [])               // Just to force a refresh on  change
    const isJoin = props.$$routeProps.$$routeKey === "/auth/join/:error?" ||
        props.$$routeProps.$$routeKey === "/auth/verify/:identity_type/:address/:code?"
    const isAuth = !isJoin;
    const tabs = [{
        label: Strings.inline("Join"),
        active: isJoin,
        onClick: () => {
            if (!isJoin)
                history.push(authSitemap.join.$$createUrl([]))
        }
    }, {
        label: Strings.inline("Login"),
        active: isAuth,
        onClick: () => {
            history.push(authSitemap.$$path)
        }
    }];

    return <AuthBackground>
        <LoginSurface radius="small" elevation={2} inactiveColor="contrast" tabs={tabs}>
            <StyledWorkspaceTitle workspaceName="" />
            {props.children}
        </LoginSurface>
    </AuthBackground>
}